import { PageSection } from "../PageSection";
import { PageHeader } from "../PageHeader";

export const Privacy = () => (
  <PageSection className="policy" id="privacy">
    <PageHeader
      className="policy-header"
      tagline="Privacy"
      subtitle="What we collect, and what we don't."
    />

    <div className="policy-content">
      <p>
        The Lil Bougie Foodie does not collect any data on visitors to this
        site, except the email address you optionally provide when signing
        up for our mailing list, and it is used solely to send you the
        mailing list updates you signed up for.
      </p>
    </div>
  </PageSection>
);
